import {databaseViewApi} from './redux/databaseView';
import {loadProcessModdle,createProcessModel} from './moddleUtils';



export async function completeProcess(dispatch, instanceID, reason="complete")
	{
	/*var process=*/await dispatch(databaseViewApi.endpoints.completeInstance.initiate({instance:instanceID,reason:reason}));
//		navigator("/");
	}

export async function advanceState(dispatch,processState,processInstance,currentState,completeProcessState,addProcessEntry,pd)
	{
	var processModel=processState.processModel;
	var processData={...pd};
	var pending=[];
	var futureStates=[];
	var shouldCompleteCurrentState=true;

	if (!processModel)
		{
		var moddle=await loadProcessModdle(dispatch,processState.processId);

		if (!moddle)
			{
			console.error("Unable to load process",processState,processState.processId);
			return [];
			}

		processModel=createProcessModel(moddle);
		}

	var startEvents=processModel.findStartingElements(currentState);

	while (startEvents.length)
		{
		var element=startEvents.shift();

		for (const transition of getPassingTransitions(element,processData))
			{
			await applyTransitionChanges(dispatch,transition,processInstance,processData,pending);
			var result=await handleTransitionTarget({
				dispatch,
				transition,
				processID:processState.processId,
				processInstance,
				currentState,
				processData,
				processModel,
				startEvents,
				futureStates,
				pending,
				addProcessEntry
				});
			if (result===false)
				shouldCompleteCurrentState=false;
			}
		}

	if (completeProcessState&&shouldCompleteCurrentState)
		pending.push(completeProcessState({instanceID:processInstance,stateID:currentState," executionID":pd[" executionID"]??null}));

	await Promise.all(pending);
	console.trace();
	console.log(futureStates);
	return futureStates;
	}	
	

function getPassingTransitions(element,processData)
	{
	if (!element.outgoing)
		return [];

	if (element.$type!=="bpmn:ExclusiveGateway"&&element.$type!=="bpmn:ComplexGateway")
		return element.outgoing;

	var passed=element.outgoing.filter((transition)=>
		{
		if (!transition.condition)
			return true;

		var condition=transition.condition.replace("#38","&");
		var result=!!window.externalEvaluate(processData,condition);

		console.log("Test result",condition,result,transition.targetRef,processData,);
		return result;
		});

	if (element.$type==="bpmn:ExclusiveGateway"&&passed.length>1)
		{
		console.warn("ExclusiveGateway has multiple valid outgoing transitions",
			element.id,
			passed.map((x)=>({id:x.id,target:x.targetRef?.id,condition:x.condition}))
			);
		}
	console.log(passed);
	return passed;
	}
	
async function handleInclusiveGateway(dispatch,transition,target,processInstance,startEvents)
	{
	var result=await dispatch(databaseViewApi.endpoints.addTransitionRecord.initiate({
		transitionID:transition.id,
		stateID:target.id,
		instanceID:processInstance
		}));

	var data=result.data?.data;

	if (!data)
		return;

	if (data.entries>=target.incoming.length)
		startEvents.push(target);
	}
async function handleTransitionTarget(context)
	{
	var {
		dispatch,
		transition,
		processID,
		processInstance,
		currentState,
		processData,
		processModel,
		startEvents,
		futureStates,
		pending,
		addProcessEntry
		}=context;
	console.log(context);
	var target=transition.targetRef;
	var completeCurrentState=true;
	switch (target.$type)
		{
		case "bpmn:Task":
		case "bpmn:SendTask":
			handleTaskTarget(target,{
					processID,
					processInstance,
					processData,
					processModel,
					futureStates,
					pending,
					addProcessEntry
					});
			if (target.id===currentState)		//we don't complete our state if we are going back
				completeCurrentState=false;
			break;

		case "bpmn:ExclusiveGateway":
			startEvents.push(target);
			break;

		case "bpmn:InclusiveGateway":
			await handleInclusiveGateway(dispatch,transition,target,processInstance,startEvents);
			break;

		case "bpmn:ComplexGateway":
			await handleComplexGateway(dispatch,transition,target,processInstance,processData,startEvents);
			break;

		case "bpmn:SubProcess":
			return handleSubProcess(target,{
					processID,
					processInstance,
					currentState,
					processModel,
					futureStates,
					pending,
					startEvents,
					addProcessEntry
					});
		
		case "bpmn:EndEvent":
			if (target.$parent.$type==="bpmn:SubProcess")
				startEvents.push(target.$parent);
			else
				pending.push(completeProcess(dispatch,processInstance));
			break;

		default:
			console.warn("Unhandled BPMN target",target.$type,target.id);
		}
//	if (target..targetRef==currentState);
	
	return completeCurrentState;
	}	
	
async function applyTransitionChanges(dispatch,transition,processInstance,processData,pending)
	{
	if (!transition.variableChanges)
		return;

	var variableChanges;

	try
		{
		variableChanges=JSON.parse(transition.variableChanges);
		}
	catch
		{
		console.warn("Invalid variableChanges",transition.id,transition.variableChanges);
		return;
		}

	var transitionData={};

	for (const change of variableChanges)
		{
		var delta=window.externalEvaluate(processData,change.value);

		if (!Object.hasOwn(processData,change.variable))
			processData[change.variable]=null;

		if (change.operation==="add")
			processData[change.variable]+=delta;
		else if (change.operation==="subtract")
			processData[change.variable]-=delta;
		else if (change.operation==="set")
			processData[change.variable]=delta;

		transitionData[change.variable]=processData[change.variable];
		}
	if (Object.keys(transitionData).length)
		{
		transitionData[' executionID']=processData[' executionID'];
		pending.push(
			dispatch(databaseViewApi.endpoints.publishProcessInstanceData.initiate({
				data:transitionData,
				instance:processInstance,
				state:transition.id,
				name:"transition"
				}))
			);
		}
	}

function handleSubProcess(target,{processID,processInstance,currentState,processModel,futureStates,pending,startEvents,addProcessEntry})
	{
	if (target.flowElements?.length)
		{
		target.flowElements.forEach((element)=>
			{
			if (element.$type==="bpmn:StartEvent")
				startEvents.push(element);
			});

		return true;
		}

	var owner=processModel.getStateOwner(target.id);

	futureStates.push(target);

	pending.push(addProcessEntry({
		instance:processInstance,
		id:processID,
		stateID:target.id,
		description:target.name,
		owner,
		parentID:target.$parent.id
		}));

	if (currentState===target.id)
		{
		console.log("Tight state loop",currentState,target.id);
		return false;
		}

	return true;
	}
	
	
function handleTaskTarget(target,{processID,processInstance,processData,processModel,futureStates,pending,addProcessEntry})
	{
	var owner=processModel.getStateOwner(target.id);

	if (owner?.startsWith("_")&&owner!=="_initiator")
		{
		if (Object.hasOwn(processData,owner))
			owner=processData[owner];
		else
			{
			console.warn("Couldn't determine owner",owner,processData);
			return;
			}
		}

	futureStates.push(target);

	pending.push(addProcessEntry({
		instance:processInstance,
		id:processID,
		stateID:target.id,
		description:target.name,
		owner,
		parentID:target.$parent.id
		}));
	}	

	
async function handleComplexGateway(dispatch,transition,target,processInstance,processData,startEvents)
	{
	if (target.incoming.length===1)
		{
		startEvents.push(target);
		return;
		}

	var result=await dispatch(databaseViewApi.endpoints.addTransitionRecord.initiate({
		transitionID:transition.id,
		stateID:target.id,
		instanceID:processInstance
		}));

	var data=result.data?.data;

	if (!data)
		return;

	var passCount=target.incoming.length;

	if (target.condition)
		{
		var condition=target.condition.replace("#38","&");
		passCount=window.externalEvaluate(processData,condition);
		console.log(passCount,condition, processData);
		if (isNaN(passCount))
			{
			console.warn("ComplexGateway returned invalid passCount",target.id,passCount);
			return;
			}
		}

	if (data.entries>=passCount)
		startEvents.push(target);
	}

